module.exports = __webpack_public_path__ + "img/caret-down.583d1e39.svg";